import React from 'react';
import { UserSubscription } from '@/lib/db/services/subscriptionService';
import { Star, Zap, Crown } from 'lucide-react';

interface SubscriptionBadgeProps {
  subscription?: UserSubscription;
}

export function SubscriptionBadge({ subscription }: SubscriptionBadgeProps) {
  const tier = subscription?.tier || 'FREE';

  const badges = {
    FREE: {
      icon: Star,
      color: 'bg-gray-100 text-gray-600',
      borderColor: 'border-gray-200',
    },
    BASIC: {
      icon: Zap,
      color: 'bg-green-100 text-green-600',
      borderColor: 'border-green-200',
    },
    PRO: {
      icon: Crown,
      color: 'bg-purple-100 text-purple-600',
      borderColor: 'border-purple-200',
    },
  };

  const { icon: Icon, color, borderColor } = badges[tier];

  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1 rounded-full border ${color} ${borderColor}`}
    >
      <Icon className="w-4 h-4" />
      <span className="text-sm font-medium">{tier}</span>
    </div>
  );
}
